import { StyleSheet } from "react-native-unistyles";
import { lightTheme, darkTheme } from "@/utils/constants/themes";

StyleSheet.configure({
    themes: {
        light: lightTheme,
        dark: darkTheme,
    },
    breakpoints: {
        xs: 0,      // Mobile phones (portrait)
        sm: 576,    // Mobile phones (landscape) / small tablets
        md: 768,    // Tablets (portrait) - show side nav from here
        lg: 992,    // Tablets (landscape) / small desktops
        xl: 1200,   // Desktops
    },
    settings: {
        adaptiveThemes: true
    }
})